import i18n from "@/lib/i18n";
import * as React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { US_STATES_LIST } from "@shared/address-validation";

export interface StateSelectProps {
  value?: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const StateSelect = React.forwardRef<HTMLButtonElement, StateSelectProps>(
  ({ value, onValueChange, placeholder = i18n.t("components.ui.stateSelect.selectState"), disabled }, ref) => {
    return (
      <Select value={value} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger ref={ref}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {US_STATES_LIST.map((state) => (
            <SelectItem key={state.value} value={state.value}>
              {state.value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  },
);

StateSelect.displayName = "StateSelect";

export { StateSelect };
